"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

var _reactScroll = require("react-scroll");

var _reactHighlightWords = _interopRequireDefault(require("react-highlight-words"));

var _Text = require("./Text.style");

var _helper = require("../../lib/utils/helper");

var _tokenMatcher = require("../../lib/utils/helper/tokenMatcher");

var _excluded = ["highlightIndex"];

var Text = function Text(_ref) {
  var children = _ref.children,
      inheritStyles = _ref.inheritStyles,
      section = _ref.section,
      _ref$rowId = _ref.rowId,
      rowId = _ref$rowId === void 0 ? '' : _ref$rowId;

  var _useSearchParams = (0, _reactRouterDom.useSearchParams)(),
      _useSearchParams2 = (0, _slicedToArray2.default)(_useSearchParams, 2),
      searchParams = _useSearchParams2[0],
      setSearchParams = _useSearchParams2[1];

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var resetSearchParmas = function resetSearchParmas() {
    var currentParams = {};

    var _iterator = (0, _createForOfIteratorHelper2.default)(searchParams.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;
        currentParams[entry[0]] = entry[1];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    setSearchParams((0, _objectSpread2.default)((0, _objectSpread2.default)({}, currentParams), {}, {
      search: '',
      rowId: '',
      rowIds: ''
    }));
    setSearch('');
  };

  var childrenText = (0, _react.useMemo)(function () {
    return (children === null || children === void 0 ? void 0 : children.toString()) || '';
  }, [children]);

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      childrenTokens = _useState4[0],
      setChildrenTokens = _useState4[1];

  var textRowId = (0, _react.useMemo)(function () {
    return "".concat(rowId || '').concat((0, _helper.generateRowId)(section, childrenText));
  }, [section, childrenText, rowId]);
  (0, _react.useEffect)(function () {
    setChildrenTokens(null);
  }, [childrenText]);
  (0, _react.useEffect)(function () {
    var _searchParams = _queryString.default.parse(searchParams.toString());

    var searchStr = _searchParams.search || '';
    var rowIds = [].concat((0, _toConsumableArray2.default)((0, _helper.tryParseJson)(_searchParams.rowIds)), (0, _toConsumableArray2.default)(_searchParams.rowId ? [_searchParams.rowId] : []));

    if (searchStr) {
      setSearch(searchStr);
    }

    if (rowIds !== null && rowIds !== void 0 && rowIds.length && (rowIds.includes(textRowId) || rowIds.includes(rowId)) && !childrenText.includes(searchStr)) {
      if (searchStr.includes(childrenText)) {
        // If rowId is provided and child text is a substring of search, 
        // use child text as search to highlight the exact match instead of the whole search string
        searchStr = childrenText;
        setSearch(searchStr);
      } else {
        // If child text does not include search string, 
        // try to find the longest common token sequence between search string and child text 
        // and use it as search string to highlight
        var searchStrTokens = (0, _tokenMatcher.tokenize)(searchStr);
        var childrenTextTokens = childrenTokens;

        if (!childrenTokens) {
          childrenTextTokens = (0, _tokenMatcher.tokenize)(childrenText);
          setChildrenTokens(childrenTextTokens);
        }

        var _findLongestCommonTok = (0, _tokenMatcher.findLongestCommonTokenSequence)(childrenTextTokens, searchStrTokens),
            _findLongestCommonTok2 = _findLongestCommonTok.longestSequence,
            longestCommonTokens = _findLongestCommonTok2 === void 0 ? [] : _findLongestCommonTok2;

        if (longestCommonTokens.length) {
          searchStr = childrenText.substring(longestCommonTokens[0].index, longestCommonTokens.at(-1).endIndex);
          setSearch(searchStr);
        }
      }
    }

    if (childrenText && searchStr && childrenText.includes(searchStr)) {
      var scrollPriority = rowIds.includes(rowId) ? 0.5 : 1;

      if (_searchParams.section && section && (0, _helper.normalizeString)(_searchParams.section) !== (0, _helper.normalizeString)(section)) {
        scrollPriority = 2;
      }

      (0, _helper.priorityScrollTo)("".concat(textRowId, "_highlighted_0"), scrollPriority);
    }
  }, [searchParams, childrenText, section]);

  var HighlightTag = function HighlightTag(_ref2) {
    var highlightIndex = _ref2.highlightIndex,
        rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    var uniqueId = "".concat(textRowId, "_highlighted_").concat(highlightIndex);
    return /*#__PURE__*/_react.default.createElement(_reactScroll.Element, {
      className: "inline",
      key: uniqueId,
      name: uniqueId
    }, /*#__PURE__*/_react.default.createElement("mark", Object.assign({
      className: "highlighted"
    }, rest)));
  };

  return /*#__PURE__*/_react.default.createElement(_reactScroll.Element, {
    key: textRowId,
    name: textRowId
  }, inheritStyles ? /*#__PURE__*/_react.default.createElement(_reactHighlightWords.default, {
    highlightClassName: "highlighted",
    searchWords: [search],
    autoEscape: true,
    textToHighlight: children,
    highlightTag: HighlightTag
  }) : /*#__PURE__*/_react.default.createElement(_Text.TextWrapper, {
    onClick: function onClick() {
      return resetSearchParmas();
    }
  }, /*#__PURE__*/_react.default.createElement(_reactHighlightWords.default, {
    highlightClassName: "highlighted",
    searchWords: [search],
    autoEscape: true,
    textToHighlight: children,
    highlightTag: HighlightTag
  })));
};

exports.Text = Text;